export default "__VITE_ASSET__CJyWfVNs__"